var dbTable = function()
{
	var instance = {};
	
	$.fn.dataTable.ext.errMode = 'throw';//throw the error, NOT alert
	
	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component, DTOptionsBuilder, DTColumnBuilder, $http)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].tableOptions = {};
		scope[componentKey].tableColumns = [];
		
		//copy the state to unbind appState change so that it doesn't trigger ajax request automatically
		var pageState = angular.copy(scope.appState);
		var pageFilter = angular.copy(scope.page_filters);
		pageFilter = typeof(pageFilter[pageState.page][pageState.submenu_key]) == "undefined" ? {} : pageFilter[pageState.page][pageState.submenu_key];
		var default_sort = typeof(component.config.default_sort) == "undefined" ? 0 : component.config.default_sort;
		var sort_direction = typeof(component.config.sort_direction) == "undefined" ? 'desc' : component.config.sort_direction;
		var order_by = typeof(component.config.order_by) == "undefined" ? 'desc' : component.config.order_by;
		var pagination = (typeof(component.config.pagination) != "undefined" && component.config.pagination == false) ? false : true;
		
		//find the key position of the sort field.
		if(typeof(default_sort) != 'number') //if its string, find the position of this field
		{
			if(typeof(component.data.header) != 'undefined')
			{
				var sort_position = 0;
				$.each(component.data.header, function(keyString, label)
				{
					if(keyString == default_sort)
					{
						default_sort = sort_position;
						return false;
					}

					sort_position++;
				});
			}
		}

		var hide_columns= [];
		if(typeof(component.config.hide_sort_columns) != 'undefined')
		{
			//TODO: Remove this if not needed
			// hide_columns = component.config.hide_sort_columns;
			// hide_columns = hide_columns.split(',');
			// hide_columns = hide_columns.map(i => !isNaN(parseInt(i)) ? parseInt(i) : i);
			var hide_sort_columns = component.config.hide_sort_columns;
			hide_sort_columns = JSON.parse("[" + hide_sort_columns + "]");;			
			hide_columns = hide_sort_columns;
		}
		
		//set table options
		scope[componentKey].tableOptions = DTOptionsBuilder.newOptions()
										   .withOption('ajax', {
										        dataSrc: function(response){
										        	//Handle exceptions here
										        	//Handle 403
														if(typeof(response.response_code) != 'undefined' && response.response_code == '403')
														{
															var url = component.config.url;
															var params = {'app_state' : pageState, 'filters' : pageFilter, 'component_key' : componentKey, 'get_total' : 1, 'order_by' : order_by};
															var invalid_request_object = {};
															invalid_request_object.request_url = url;
															invalid_request_object.request_params = params;
															invalid_request_object.response = response;

															//REVIEW: using scope instead of rootScope
															scope.$emit('invalid_request_in_response', invalid_request_object);

															return false;
														}
													
													if($('#'+componentKey+'_push_report_region_title').length)
													{
														var category_title = typeof(response['data'][componentKey]['region']) == "undefined" ? null : response['data'][componentKey]['region'];
														if(category_title)
														{
															$('#'+componentKey+'_push_report_region_title').html(category_title);
														}
													}
													//keep the result data in a new node for the component
										    		scope[componentKey]['data'] = response['data'][componentKey]['data'];
										    		return response['data'][componentKey]['data'];
										    	},
										        url: component.config.url,
										        type: 'POST',
										        data : {'app_state' : pageState, 'filters' : pageFilter, 'component_key' : componentKey, 'get_total' : 1, 'order_by' : order_by}
										    })
										    .withOption('order', [default_sort, sort_direction])
										    .withOption('bLengthChange', false)
										    .withOption('processing', true)
										    .withOption('serverSide', true)
										    .withOption('searching', false)
										    .withOption('paging', pagination)
										    .withOption('info', pagination)
											.withOption('lengthMenu', [10, 25, 50, 100])
											.withOption('aoColumnDefs', [{'bSortable' : false, 'aTargets' : hide_columns }])
											.withOption('language', 
													{ 
														"info": "Showing _START_ to _END_ of _TOTAL_ records", 
														"lengthMenu"  : "_MENU_ records per page", 
														"processing"  : "<div class='la-square-jelly-box la-2x'><div></div><div></div></div>",
														"zeroRecords" : "No data to display"
													})
											.withOption('headerCallback', headerCallback)
											.withOption('drawCallback', drawCallback)
										    .withPaginationType('full_numbers').withDisplayLength(component.config.limit);
		
		//look for click event
		if(typeof(component.config.rowclick) != 'undefined')
		{
			scope[componentKey].tableOptions.withOption('rowCallback', rowCallback);
			scope[componentKey].tableOptions.withOption('createdRow', createdRow);
		}

		//look for row tooltip
		if(typeof(component.config.rowTooltip) != 'undefined')
		{
			// scope[componentKey].tableOptions.withOption('rowCallback', rowCallback);
			scope[componentKey].tableOptions.withOption('createdRow', rowTooltip);
		}

		if(typeof(component.config.highlight_matching_filter_row) != 'undefined')
		{
			scope[componentKey].tableOptions.withOption('createdRow', highlightRow);
			if(typeof(component.config.no_scroll_to_highlighted_row) == 'undefined' || component.config.no_scroll_to_highlighted_row != true)
			{
				scope[componentKey].tableOptions.withOption('initComplete', scrollToHighlightRow);
			}
		}

		if(typeof(component.config.highlight_matching_value_row) != 'undefined')
		{
			scope[componentKey].tableOptions.withOption('createdRow', highlightValueRow);
		}

		if(typeof(component.config.scrollX) != 'undefined')
		{
			scope[componentKey].tableOptions.withOption('scrollX', component.config.scrollX);
		}
		
		//set table columns
		$.each(component.data.header, function(key, heading)
		{
		    //if column width undefined, set default
		    var column_width = (typeof(component.config.width) == "undefined" || typeof(component.config.width[key]) == "undefined") ? 50 : component.config.width[key];	
		    var column_className = (typeof(component.config.className) == "undefined" || typeof(component.config.className[key]) == "undefined") ? '' : component.config.className[key];
		    var order_sequence = (typeof(component.config.orderSequence) == "undefined" || typeof(component.config.orderSequence[key]) == "undefined") ? ["desc", "asc"] : component.config.orderSequence[key];
		    
        	var column_push  = DTColumnBuilder.newColumn(key)
				.withTitle(heading)
				.withOption('width', column_width+'%')
				.withOption('className', column_className)
				.withOption('orderSequence', order_sequence)
				.withOption('createdCell', function (td, cellData, rowData, row, col) {
					var newCellData = cellData;
					//look if highlightSearchColumn is defined
					if(typeof(component.config.highlightSearchColumn) != 'undefined')
					{
						var indexFilterMap = component.config.highlightSearchColumn;
						//check if the column index is defined
						if(typeof(indexFilterMap[col]) != 'undefined')
						{
							var filterBoxId = indexFilterMap[col];
							var text = $('#'+filterBoxId).val();
							
							if(typeof(text) != 'undefined' && text != '' && text != null && typeof(cellData) != 'undefined' && cellData != '' && cellData != null)
							{	
								newCellData = cellData.replace(new RegExp('('+text+')', 'gi'), "<span class='highlight'>$1</span>");
							}
						}
					}
					
					//look for anonymous options
					var header_data = component.data.header;
					var columnKey = Object.keys(header_data)[col];
					var anonymous_col = columnKey+'_anonymous';

					var disable_anonymous_metric_hovers = false;
					disable_anonymous_metric_hovers = (typeof(rowData['disable_anonymous_metric_hovers']) != 'undefined' && rowData['disable_anonymous_metric_hovers'] === true);

					if(typeof(rowData[anonymous_col]) != 'undefined')
					{
						if (disable_anonymous_metric_hovers)
						{
							newCellData = rowData[anonymous_col];
						}
						else {
							newCellData = '<div class="data_cell">' + newCellData + '</div><div class="anonymous_cell hide">' + rowData[anonymous_col] + '</div>'
							$(td).hover(
								function (e) {
									if (e.type === 'mouseenter') {
										$(this).find(".data_cell").addClass('hide');
										$(this).find(".anonymous_cell").removeClass('hide');
									}
								},
								function (e) {
									if (e.type === 'mouseleave') {
										$(this).find(".data_cell").removeClass('hide');
										$(this).find(".anonymous_cell").addClass('hide');
									}
								}
							);

							if (typeof (component.config.anonymous_display_metric) != 'undefined' && typeof (component.config.anonymous_display_color) != 'undefined') {
								var anonymous_metric_match_data = component.config.anonymous_display_color;
								var anonymous_metric = component.config.anonymous_display_metric;
								$.each(anonymous_metric_match_data, function (key, value) {
									if (typeof (rowData['can_access_anonymous_metrics']) != 'undefined' && rowData['can_access_anonymous_metrics'] === true && typeof (rowData[anonymous_metric]) != 'undefined' && rowData[anonymous_metric] == key) {
										var color = (typeof (value['color']) != 'undefined') ? value['color'] : '#565656';
										$(td).closest('tr').css('color', color);
									}
								});
							}
						}

					  	//update the cell with the new data
					  	$(td).html(newCellData);
					}
				});

			var display_flag = false;
			//look for click event hidden column
			if(typeof(component.config.click_key) != 'undefined' && component.config.click_key == key)
			{
				scope[componentKey].tableColumns.push(column_push.notVisible());
				display_flag = true;
			}
			else if(typeof(component.config.notvisible) != 'undefined' && $.inArray(key, component.config.notvisible) !== -1 )
			{
			    scope[componentKey].tableColumns.push(column_push.notVisible());
                display_flag = true;
			}
			else
			//Look for format options
			if(typeof(component.column_format) != 'undefined')
			{
				var columnFormat = component.column_format;
				//Date Time Format Check
				if(typeof(columnFormat.dateTimeKeys) != 'undefined')
				{
					$.each(columnFormat.dateTimeKeys, function(i, keyName)
					{
						if(keyName == key)
						{
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type) {
								var t_date = new Date(data*1000);
								return t_date.toString(); //date filter
							}));
							display_flag = true;
						}
					});
				}

				//Format Date field
				if(typeof(columnFormat.formatMysqlDateKeys) != 'undefined')
				{
					$.each(columnFormat.formatMysqlDateKeys, function(i, keyName)
					{
						if(keyName == key)
						{
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type) {
								var t_date = new Date(data);
								if(typeof(columnFormat.mysqlDateFormat) != 'undefined' && columnFormat.mysqlDateFormat == 'timestamp'){
									var t_date = new Date(data*1000);
								}
								return t_date.toLocaleDateString("en-au", {year: "numeric", month: "numeric",day: "numeric"}); //date filter
							}));
							display_flag = true;
						}
					});
				}
				
				//Replace Text (e.g.hot alert status flag)
				if(typeof(columnFormat.replaceText) != 'undefined')
				{
					$.each(columnFormat.replaceText, function(i, replaceRule)
					{
						if(replaceRule.column == key)
						{
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type) {
								var replacedText = '';
								if(typeof(replaceRule.replace) != 'undefined' && typeof(replaceRule.replace[data]) != 'undefined')
								{
									replacedText = replaceRule.replace[data];
								}

								return replacedText; 
							}));
							
							display_flag = true;
						}
					});
				}

				//Replace Text (e.g.hot alert status flag)
				if(typeof(columnFormat.replaceValueWithHtml) != 'undefined')
				{
					$.each(columnFormat.replaceValueWithHtml, function(i, replaceRule)
					{
						if(replaceRule.column == key)
						{
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type, full) {
								var replacedText = '';

								var id_column = replaceRule.id_column;
								var id_value = typeof full[id_column] != 'undefined'? full[id_column] : '';

								// console.log(cellData);
                                if(typeof(replaceRule.html) != 'undefined')
                                {
                                    replacedText = replaceRule.html;
                                    replacedText = replacedText.replace(new RegExp("\{data-id\}", 'g'), id_value);
                                    replacedText = replacedText.replace(new RegExp("\{data-value\}", 'g'), data);
                                }

								return replacedText;
							}));

							display_flag = true;
						}
					});
				}

				//Display action colmn html
				if(typeof(columnFormat.actionColumnFormat) != 'undefined')
				{
					$.each(columnFormat.actionColumnFormat, function(i, replaceRule)
					{
						if(replaceRule.column == key)
						{
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type, full) {
								var replacedText = typeof replaceRule.html_start != 'undefined' ? replaceRule.html_start :'';
								//Loop and add the actions
								var actions = typeof replaceRule.actions != 'undefined' ? replaceRule.actions :[];
								var show = typeof replaceRule.show != 'undefined' ? replaceRule.show :[];
								$.each(actions, function(action_key, action_val){
									var new_display_rule = typeof show[action_key] != 'undefined' ? show[action_key] :null;
									if(new_display_rule != null){
										if(typeof scope[new_display_rule] != 'undefined' && scope[new_display_rule] == false){
											return true;//continue
										}
									}
									replacedText += action_val;
								});

								replacedText += typeof replaceRule.html_end != 'undefined' ? replaceRule.html_end :'';

								var id_column = replaceRule.id_column;
								var id_value = typeof full[id_column] != 'undefined'? full[id_column] : '';

								// console.log(cellData);
                                if(replacedText != '')
                                {
                                    replacedText = replacedText.replace(new RegExp("\{data-id\}", 'g'), id_value);
                                    replacedText = replacedText.replace(new RegExp("\{data-value\}", 'g'), data);
                                }

								return replacedText;
							}));

							display_flag = true;
						}
					});
				}

				//Display Files
				if(typeof(columnFormat.displayFile) != 'undefined')
				{
					$.each(columnFormat.displayFile, function(i, displayRule)
					{
						if(displayRule.column == key)
						{
							
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type, full) {
								var replacedText = '';

								var id_column = displayRule.id_column;
								var id_value = typeof full[id_column] != 'undefined'? full[id_column] : '';
                                if(typeof(displayRule.format) != 'undefined')
                                {
                                	var filename = data.lastIndexOf('.') != -1 ? data.substring(0, data.lastIndexOf('.')) : data;
                                	var extension = data.lastIndexOf('.') != -1 ? data.substring(data.lastIndexOf('.')+1, data.length): "";
                                	extension = extension.toUpperCase();

                                	var fileicon = "";
                                	var icons = typeof(displayRule.icons) != 'undefined'?displayRule.icons:null;
                                	if(icons){
                                		fileicon = typeof(icons[extension]) != 'undefined'?icons[extension]:"";
                                	}
                                    replacedText = displayRule.format;
                                    replacedText = replacedText.replace(new RegExp("file-name", 'g'), filename);
                                    replacedText = replacedText.replace(new RegExp("file-type", 'g'), extension);
                                    replacedText = replacedText.replace(new RegExp("file-icon", 'g'), fileicon);
                                    replacedText = replacedText.replace(new RegExp("data-value", 'g'), id_value);
                                }

								return replacedText;
							}));

							display_flag = true;
						}
					});
				}
				
				//complex formatting (e.g. ranking top/bottom icon)
				if(typeof(columnFormat.formatObject) != 'undefined')
				{
					$.each(columnFormat.formatObject, function(i, formatRule)
					{
						if(formatRule.column == key)
						{
							scope[componentKey].tableColumns.push(column_push.renderWith(function(data, type) {
								
								if(typeof(data) == 'object')
								{
									var formattedText = $('<div></div>');
									
									//loop through format options for each field and apply
									if(typeof(formatRule.format) != 'undefined')
									{
										$.each(formatRule.format, function(formatField, formatRule)
										{
											//add text to html
											if(formatRule == 'text')
											{
												formattedText.append($("<span>" + data[formatField] + "</span>"));
											}	
											
											//add class to html
											if(formatRule == 'className')
											{
												formattedText.addClass(data[formatField]);
											}
											
											//add class to html
											if(formatRule == 'className')
											{
												formattedText.addClass(data[formatField]);
											}
											
											//complex rules
											if(typeof(formatRule) == 'object')
											{
												if(typeof(formatRule['rule']) != 'undefined')
												{
													if(formatRule['rule'] == 'addHtml')
													{
														var htmlToAdd = '';
														if(typeof(formatRule.html) != 'undefined' && typeof(formatRule.html[data[formatField]]) != 'undefined')
														{
															htmlToAdd = formatRule.html[data[formatField]];
														}	
														formattedText.append($(htmlToAdd));
													}	
												}	
											}
											
										});		
									}	
									
									//add to a container to get html string
									var container = $('<div></div>').append(formattedText);
									
									return $(container).html();
								}
								else
								{
									return data;
								}	
							}));
							
							display_flag = true;
						}
					});
				}

			}

			if(!display_flag)
			{
				scope[componentKey].tableColumns.push(column_push);
			}
			
		});
		
		//add rowclick event
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) 
		{
	        // Unbind first in order to avoid any duplicate handler
	        $('td', nRow).unbind('click');
	        $('td', nRow).bind('click', function() {
	        	$(nRow).parent().find('tr').removeClass('selected');
	        	$(nRow).addClass('selected');
	        	scope.$apply(function() {
	        		scope[componentKey].selectedRowIndex = iDisplayIndex;
	        		scope[componentKey].selectedRow = nRow;
	        		scope[component.config.rowclick_action](aData, component, componentKey);
	            });
	        });
	        return nRow;
	    }
		
		//add attribute(id) to each row
		function createdRow( row, data, index ) 
		{
			//add unique key as id of the row (used to scroll to this row)
			$(row).attr('id', data[component.config.click_key]);
			$(row).addClass('clickable');
		}

		function rowTooltip( row, data, index ) 
		{
			var format = typeof component.config.rowTooltipFormat != 'undefined' ? component.config.rowTooltipFormat : {};
			var template = typeof format.template != 'undefined' ? format.template : '';
			var replaceValues = typeof format.replaceValues != 'undefined' ? format.replaceValues : {};
			var display_for_indexes = typeof format['display_for_indexes'] != 'undefined' ? format.display_for_indexes : null;

			if(template != ''){
				//Iterate over the replace values
				$.each(replaceValues, function( key, value ) {
				  value = typeof data[value] != 'undefined' ? data[value] : '';
				  // console.log(key+':'+value);
				  template = template.replace('{'+key+'}', value);
				});

				$(row).find("td").each(function(i, ele) 
				{
					if(display_for_indexes != null && typeof display_for_indexes != 'undefined')
					{
						//check the visible indexes
						if(display_for_indexes.indexOf(i) != -1)
						{
							//Add a tooltip wrapper container
							var text = $(this).html();
							var newElement = document.createElement('div');
							$(newElement).attr('class', 'tooltip-element-wrap');
							$(newElement).attr('data-title', template);
							$(newElement).attr('data-toggle', 'tooltip');
							$(newElement).attr('data-html', true);
							newElement.setAttribute('href',"javascript:void(0)");
							newElement.innerHTML = text;
							$(this).html(newElement);
						}
					}
					else
					{
						$(this).attr('data-title', template);
						$(this).attr('data-html', true);
						$(this).attr('data-toggle', 'tooltip');
					}
				})

				// $(row).attr('data-title', template);
				// $(row).attr('data-toggle', 'tooltip');
				// $('body').tooltip({selector: '[data-toggle="tooltip"]', "placement":"bottom", "html":true, "delay":0, "track":true, "fade":250, container: '#'+componentKey});
			}
		}

		//Highlight rows when its given metric value matches the given app state filter
		function highlightRow( row, data, index )
		{
			if( typeof(component.config.highlight_matching_filter_row) != 'undefined')
			{
				var metric_filter_match_data = component.config.highlight_matching_filter_row;
				$.each( metric_filter_match_data, function( key, value )
				{
					if( typeof(data[key]) != 'undefined' && typeof(pageState[value]) != 'undefined' && data[key] == pageState[value])
					{
						$(row).addClass('selected');
					}
				});

				//adding highligh to records which has highlight key exists in result data
				/*if(typeof(data['highlight']) != 'undefined')
				{
					$(row).addClass('selected');
				}*/
			}
		}

		//Highlight rows when its given metric value matches the pre-defined value
		function highlightValueRow( row, data, index )
		{
			if( typeof(component.config.highlight_matching_value_row) != 'undefined')
			{
				var metric_filter_match_data = component.config.highlight_matching_value_row;
				$.each( metric_filter_match_data, function( key, value )
				{
					if( typeof(data[key]) != 'undefined' && typeof(value) != 'undefined' && value.includes(data[key]))
					{
						if( typeof(component.config.highlight_matching_value_row_class) != 'undefined')
						{
							$(row).addClass(component.config.highlight_matching_value_row_class);
						}
					}
				});
			}
		}

		//function to scroll to the highlighted row when the table is initialized
		function scrollToHighlightRow()
		{
			var container = $('html,body'),
				scrollTo = $('#'+ componentKey +' .selected');
				if(scrollTo.length > 0)
				{	
					setTimeout(function(){
						if(typeof(scrollTo) != 'undefined')
						{	
							container.animate({
								scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop() - 80
							}, 500);
						}
					}, 300);
				}
		}
		
		function headerCallback(thead, data, start, end, display)
		{
			if(typeof(component.config.headerClassName) != 'undefined')
			{
				$.each(component.config.headerClassName, function(columnIndex, className)
				{
					$(thead).find('th').eq(columnIndex).addClass(className);
				});
			}
			
			//Add all the text of header columns as its title
			$(thead).find("th").each(function() 
			{
				// this.title = $(this).text();
				$(this).attr('data-title', $(this).text());
			})

			if(typeof(component.config.headerTooltip) != 'undefined' && component.config.headerTooltip == true)
			{
				//Add header tooltip
				$('#'+componentKey+'_wrapper thead').find('th').attr('data-toggle', 'tooltip');
				$('#'+componentKey+'_wrapper').tooltip({selector: '[data-toggle="tooltip"]', "placement":"auto", "html":true, "delay":0, "track":true, "fade":250, container: '#'+componentKey+'_wrapper'});
			}
		}

		function drawCallback(settings)
		{
			
			delete scope.httpPendingComponents[componentKey];
			//Log the end time
			scope.httpComponentEndTimeLogs[componentKey] = new Date().getTime();

			if(typeof(scope.httpPendingComponents) != 'undefined' && Object.keys(scope.httpPendingComponents).length == 0)
			{
				$('body').attr('data-loaded', true);

				//set the client request end time if logging is active
				var activity_log_id = typeof(scope.activity_log_id) != 'undefined' ? scope.activity_log_id : '';
				if(activity_log_id){
					//Send a request to server
					$http({
						url: 'common/page_load_complete', 
						data:{
							'app_state' : scope.appState, 
							'activity_log_id' : activity_log_id, 
							'component_start_times' : scope.httpComponentStartTimeLogs,
							'component_end_times' : scope.httpComponentEndTimeLogs
						}, 
						method: 'POST', 
						withCredentials: true, 
						headers: {"X-Requested-With" : "XMLHttpRequest"}, 
						// timeout: canceller.promise, 
						ignoreLoadingBar:true
					}).then(function(response) {
							if(typeof(response.data) != 'undefined')
							{
								// console.log('data load complete ');
							}
						}
					);
				}
			}
			//Called when data load is complete

			//scrollbar visible from left to right without scrolling down //AU009-46
			if('floating_scroll' in component)
			{
				if(angular.isArray(component.floating_scroll)){

					angular.forEach(component.floating_scroll, function (value, key) { 
						placeHolder = ('place_holder' in component)? component.place_holder : value;
                    	$(value).floatingScroll("init", {place_holder: placeHolder});
                	}) ;	
				}
				else{
					placeHolder = ('place_holder' in component)? component.place_holder : component.floating_scroll;	
					$(component.floating_scroll).floatingScroll("init", {place_holder: placeHolder});
				}
			}
			
            var pagination = (typeof(component.config.pagination) != "undefined" && component.config.pagination == false) ? false : true;
			if(pagination === true) {
                //show pagination
                try {
                    $('#'+ componentKey).closest('.dataTables_wrapper').find('.dataTables_paginate').show();
                }
                catch(e) {}

                //hid pagination if no data found
                try {
                    var current_pages_info = scope[componentKey].instance.DataTable.page.info();
                    if(typeof(current_pages_info) != 'undefined') {
                        if(typeof(current_pages_info.pages) != 'undefined' && current_pages_info.pages == 0) {
                            $('#'+ componentKey).closest('.dataTables_wrapper').find('.dataTables_paginate').hide();
                        }
                    }
                }
                catch(e) {}
			}

			if(typeof(component.config.rowTooltip) != 'undefined' && component.config.rowTooltip == true)
			{
				//Add row tooltip
				$('body').tooltip({selector: '[data-toggle="tooltip"]', "placement":"auto", "html":true, "delay":0, "track":true, "fade":250, container: '#'+componentKey+'_wrapper'});
			}

		}

		function formatDate(data, type, full, meta) {
			return $filter('date')(data, 'dd/MM/yyyy'); //date filter
		}

		function paginateScroll() {
			var scroll_value = $(this).closest(".dataTables_wrapper").offset().top;
			$("html, body").animate({ scrollTop: scroll_value }, "slow");
			return false;
		}
		$('body').off('click', "#"+componentKey+"_wrapper .paginate_button:not(.disabled)", paginateScroll);
		$('body').on('click', "#"+componentKey+"_wrapper .paginate_button:not(.disabled)", paginateScroll);
	};
	
	return instance;
};
